import { Collection } from 'backbone';

export class SooMatches extends Collection {
	initialize(){
		this.prefix = 'nrl/';
		this.url = 'matches/so.json';
	}
}

export default SooMatches;